<template>
	<div class="d-flex flex-column">
		<div 
			v-for="(feature, index) in features" :key="index"
			class="d-flex">
			<p class="title-counter">{{feature.name}}</p>
			<div class="d-flex wrap">
				<button 
					v-for="(value, indexValue) in feature.values"
					:key="indexValue"
					class="item-color"
					:class="{'active': value.active, 'possible': value.possible}"
					@click="$emit('select', index, indexValue)"
				>{{value.name}}</button>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'features',
	props: {
		features: {
			type: Array,
			default: () => [],
		},
	},
};
</script>
<style lang="scss" scoped>
	.title-counter {
		color: color(titleGrey);
		font-family: font(open-semibold);
		font-size: size(maxsmall);
		margin: 1.3rem 1rem 1rem 0;
		min-width: 11.9rem;
	}

	.wrapper-padding {
		padding: 1.6rem 5%;
	}

	.item-color {
		background: color(whiteBold);
		border: none;
		color: color(titleGrey);
		cursor: pointer;
		font-size: size(normal);
		margin: 0 1.5rem 1.2rem 0;
		outline: none;
		padding: 1.5rem 1.6rem;
		transition: all .4s ease-in-out 0s;
		
		&:hover, &.active {
			background: color(blackBold);
			color: white;
		}

		&.possible {
			background: color(redBold);
			color: color(white);
		}
	}

	@media screen and (max-width: 1024px) {
		.title-counter {
			font-size: size(msmall);
		}

		.item-color {
			font-size: size(small);
			padding: 1.2rem;
		}
	}
</style>





// WEBPACK FOOTER //
// features.vue?73d72e90